export default "skymp5-front/9ae6d468940c40f76158b3edaf45e8e2.png";